module.exports = __webpack_public_path__ + "img/chengGuo-zhanWei-home.a47b8f5.png";